import { render, staticRenderFns } from "./FriendlyUrl.vue?vue&type=template&id=13440480&scoped=true&"
import script from "./FriendlyUrl.vue?vue&type=script&lang=js&"
export * from "./FriendlyUrl.vue?vue&type=script&lang=js&"
import style0 from "./FriendlyUrl.vue?vue&type=style&index=0&id=13440480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13440480",
  null
  
)

export default component.exports